import React,{Component} from 'react';
import yesIcon from '../../images/yes.svg';
import noIcon from '../../images/no.svg';
import Popover from '../../Shared/Popover';
import PropTypes from 'prop-types'

class SubdomainPlans extends Component{
    constructor(){
        super();
        this.onYesClick = this.onYesClick.bind(this);
        this.onNoClick = this.onNoClick.bind(this);
    }
    onYesClick(e){
        e.preventDefault();
        const {parent} = this.props;
        if(parent){
            const {mode} = parent.state;
            if(mode==='Business'){
                parent.setState({
                    ...parent.state,
                    page: 'WildcardPlans'
                })
            }else{
                parent.setState({
                    ...parent.state,
                    page: 'PersonalSecurePlans'
                })
            }
        }
    }
    onNoClick(e){
        e.preventDefault();
        const {parent} = this.props;
        const {mode} = parent.state;
        if(mode==='Business'){
            parent.setState({
                ...parent.state,
                page: 'AcceptingPaymentPlans'
            })
        }else{
            parent.setState({
                ...parent.state,
                page: 'PersonalPlans'
            })
        }
    }
    render(){
        const {parent} = this.props;
        return(<div className={`SSL-Selector__Page SSL-Selector__Page--SubdomainPlans`}>
                <div className={`SSL-Selector__description clearfix`}>Are you planning on using <Popover />?</div>
                <div className={`SSL-Selector__actions clearfix`}>
                    <div className={`SSL-Selector__button`} onClick={this.onYesClick}>
                        <img className={`button__icon`} src={yesIcon} alt={`Yes`} />
                        <div className={`button__text`}>Yes</div>
                    </div>
                    <div className={`SSL-Selector__button`} onClick={this.onNoClick}>
                        <img className={`button__icon`} src={noIcon} alt={`No`} />
                        <div className={`button__text`}>No</div>
                    </div>
                </div>
                <div className={`clear`}></div>
                <div className={`SSL-Selector__link`} onClick={parent.resetAll}>Start Over</div>
            </div>
        )
    }
}

SubdomainPlans.propTypes = {
    parent: PropTypes.object
}

export default SubdomainPlans;